import { CSSProperties } from "react";
import { DCUIThemeGeneral } from '@iddataweb/idw-common-ui/types';
import { ButtonSizeTypes } from "@enums/button-size-types";
import { ButtonTypes } from "@enums/button-types";
import { ButtonWithSpinner } from "../../button-with-spinner/button-with-spinner";

type DCUIThemingPrimaryButtonProps = {
    generalTheme: DCUIThemeGeneral;
    id?: string;
    type: ButtonTypes;
    disabled: boolean;
    label: string;
    buttonSize?: ButtonSizeTypes;
    hideSpinner?: boolean;
    className?: string;
    automationId?: string;
    onClick?: () => void;
};

export const DCUIThemingPrimaryButton = (props: DCUIThemingPrimaryButtonProps) => {
    const { generalTheme, id, hideSpinner, type, disabled, label, buttonSize, className, automationId, onClick } = props;

    const primaryButtonStyle: CSSProperties = {
        borderColor: generalTheme.mainColor,
        background: generalTheme.mainColor,
        color: generalTheme.mainTextColor
    };

    return (
        <ButtonWithSpinner
            id={id}
            automationId={automationId}
            style={primaryButtonStyle}
            disabled={disabled}
            hideSpinner={hideSpinner}
            label={label}
            type={type}
            buttonSize={buttonSize}
            className={className}
            variant={"primary"}
            onClick={onClick}
        />
    );
};